import { Axios } from 'axios'
import { RootState } from '@/store'

export interface ClearCacheService {
  clearKamokuCache (startDate: string, endDate: string): Promise<void>;
}

export class ClearCacheServiceImpl implements ClearCacheService {
  constructor (http: Axios) {
    this.http = http
  }

  private readonly http: Axios

  async clearKamokuCache (startDate: string, endDate: string): Promise<void> {
    await this.http.post(
      'clear-cache/kamoku-list',
      {
        startDate: startDate,
        endDate: endDate
      }
    )
  }
}
